import { z } from "@reflag/shared/utils/zod";

import { APIEmptyResponse, APIResponse } from "./api";
import {
  FeatureListColumn,
  FeatureListColumnSchema,
  FeatureListSortBy,
  FeatureListSortBySchema,
} from "./featureAPI";
import { nameSchema } from "./schemas/nameSchema";
import { ColumnState } from "./types/columns";

export interface FeatureViewDTO {
  id: string;
  name: string;
  type: "all" | "archived" | "stale" | "custom" | "my";
  columns: ColumnState<FeatureListColumn>[];
  columnSortKey?: FeatureListSortBy;
  columnSortDesc?: boolean;
}

export const CreateFeatureViewArgsSchema = z
  .object({
    name: nameSchema,
    featureIds: z.array(z.string()).optional(),
    columns: z
      .array(
        z.object({
          id: FeatureListColumnSchema,
          shown: z.boolean(),
        }),
      )
      .optional(),
    columnSortKey: FeatureListSortBySchema.optional(),
    columnSortDesc: z.boolean().optional(),
  })
  .strict();

export const PatchFeatureViewArgsSchema = CreateFeatureViewArgsSchema.partial();

export type PatchFeatureViewArgsType = z.infer<
  typeof PatchFeatureViewArgsSchema
>;

export const PatchSystemFeatureViewArgsSchema =
  CreateFeatureViewArgsSchema.pick({
    columns: true,
    columnSortKey: true,
    columnSortDesc: true,
  });

export type CreateFeatureViewArgsType = z.infer<
  typeof CreateFeatureViewArgsSchema
>;

export interface FeatureViewAPI {
  "/apps/:appId/feature-views": {
    GET: {
      response: APIResponse<FeatureViewDTO[]>;
      params: { appId: string };
    };
    POST: {
      body: CreateFeatureViewArgsType;
      response: APIResponse<FeatureViewDTO>;
      params: { appId: string };
    };
  };
  "/apps/:appId/feature-views/:viewId": {
    GET: {
      response: APIResponse<FeatureViewDTO>;
      params: { appId: string; viewId: string };
    };
    PATCH: {
      body: PatchFeatureViewArgsType;
      response: APIResponse<FeatureViewDTO>;
      params: { appId: string; viewId: string };
    };
    DELETE: {
      response: APIEmptyResponse;
      params: { appId: string; viewId: string };
    };
  };
}
